import { QRCodeSVG } from 'qrcode.react';
import { useEffect, useRef, useState } from 'react';
import Barcode from 'react-barcode';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TAROFF_API_URL, postData } from '../../Api';
import {
    MobileInfoBox,
    Modal,
    PanelBox,
    TextView,
    Title,
} from '../../components/Display';
import {
    Button,
    DataSelect,
    MultiSelectBox,
    TextBox,
    SearchBox
} from '../../components/Form';
import {
    LeftComponents,
    RightComponents,
    Row
} from '../../components/Layout';
import {
    TableBody,
    TableColumn,
    TableData,
    TableHeader,
    TableRow,
} from '../../components/Table';
import { SearchDateBox } from '../../components/Form';

export const PrePrintInvoice = ({ onDismiss }) => {
    const invoiceRef = useRef(null);
    const iframeRef = useRef(null);
    const [invoiceData, setInvoiceData] = useState({ data: [], shop_info: null });
    const [loading, setLoading] = useState(true);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        // Fetch invoice data based on the current filters
        const fetchInvoiceData = async () => {
            setLoading(true);
            try {
                // Extract filter values from search params
                const filterParams = {
                    q_id: searchParams.get('q-id') || '',
                    q_shop_id: searchParams.get('q-shop-id') || '',
                    from_barcode: searchParams.get('from-barcode') || '',
                    to_barcode: searchParams.get('to-barcode') || '',
                    q_insert_time_from: searchParams.get('q-insert-time-from') || '',
                    q_insert_time_to: searchParams.get('q-insert-time-to') || '',
                    q_assign_time_from: searchParams.get('q-assign-time-from') || '',
                    q_assign_time_to: searchParams.get('q-assign-time-to') || '',
                };

                const response = await postData('/api/panel/page/taroff-pre-print-barcodes/invoice-data', filterParams);
                if (response.status === 'success') {
                    setInvoiceData(response);
                }
            } catch (error) {
                console.error('Error fetching invoice data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchInvoiceData();

        // Create the iframe when component mounts
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.border = '0';
        iframe.style.left = '0';
        iframe.style.top = '0';
        iframe.style.zIndex = '10';
        document.body.appendChild(iframe);
        iframeRef.current = iframe;

        // Cleanup function to remove iframe when component unmounts
        return () => {
            if (iframeRef.current) {
                document.body.removeChild(iframeRef.current);
            }
        };
    }, [searchParams]);

    const printInvoice = () => {
        // Get the content of the invoice
        const invoiceContent = invoiceRef.current;

        // Use the iframe for printing
        const iframe = iframeRef.current;
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

        // Write the invoice content to the iframe
        iframeDoc.open();
        iframeDoc.write(`
            <html dir="rtl">
                <head>
                    <title>فاکتور پریپرینت</title>
                    <style>
                        .barcode {
                            width: 100%;
                        }
                        body {
                            color: #000;
                            font-family: Tahoma, Arial, sans-serif;
                            direction: rtl;
                            text-align: right;
                        }
                        @media print {
                            body {
                                margin: 0;
                                padding: 0;
                            }
                            * {
                                color: #000;
                            }
                            .page-break {
                                page-break-after: always;
                            }
                            .invoice-container {
                                border: none !important;
                                box-shadow: none !important;
                            }
                        }
                    </style>
                    <script>
                        document.addEventListener('DOMContentLoaded', function() {
                            window.print();
                        });
                    </script>
                </head>
                <body>
                    ${invoiceContent.innerHTML}
                </body>
            </html>
        `);
        iframeDoc.close();
    }

    // Helper function to ensure a tracking code exists
    const getTrackingCode = (order) => {
        return order.text_title;
    };

    if (loading) {
        return (
            <>
                <Row>
                    <RightComponents>
                        <Title>فاکتور پریپرینت</Title>
                    </RightComponents>
                </Row>
                <div>در حال بارگذاری...</div>
                <Row>
                    <LeftComponents>
                        <Button onClick={onDismiss}>انصراف</Button>
                    </LeftComponents>
                </Row>
            </>
        );
    }

    return <>
        <Row>
            <RightComponents>
                <Title>فاکتور پریپرینت</Title>
            </RightComponents>
        </Row>
        <div ref={invoiceRef} style={{ width: '300px', containerType: 'inline-size' }}>
            <div style={{ fontSize: '3cqw' }}>
                {invoiceData.data.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        سفارشی یافت نشد.
                    </div>
                ) : (
                    invoiceData.data.map((order, index) => {
                        const trackingCode = getTrackingCode(order);

                        return (
                            <div key={order.text_id} style={{ pageBreakInside: 'avoid', pageBreakAfter: 'always' }}>
                                {[0, 1].map((repeat) =>
                                    <div className="invoice-container" style={{
                                        color: '#000',
                                        maxWidth: '100%',
                                        margin: '0 auto',
                                        fontFamily: 'IranSans, Tahoma, Arial, sans-serif',
                                        direction: 'rtl',
                                        padding: '0 2cqw',
                                        // border: '1px solid #eee',
                                        // borderRadius: '8px',
                                        // boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                                        backgroundColor: '#fff',
                                        pageBreakInside: 'avoid',
                                        pageBreakAfter: 'always'
                                    }}>
                                        {/* First label - Top barcode with logos */}
                                        <div className="tracking-label" style={{
                                            position: 'relative',
                                            padding: '0',
                                            marginBottom: '2cqw',
                                            // borderRadius: '8px',
                                            // border: '1px solid #eee',
                                            backgroundColor: '#fff'
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}>
                                                {/* Right side logo */}
                                                <div style={{ width: '15%' }}>
                                                    <img src={`${process.env.PUBLIC_URL}/post-logo-small.png`} alt="Post Logo" style={{ width: '100%' }} />
                                                </div>

                                                {/* Center section - just barcode */}
                                                <div style={{
                                                    textAlign: 'center',
                                                    flexGrow: 1,
                                                    width: '70%'
                                                }}>
                                                    <div style={{
                                                        fontSize: '3cqw',
                                                        marginBottom: '2cqw'
                                                    }}>
                                                        برچسب کد رهگیری و اعتبارسنجی 3PDL
                                                    </div>
                                                    <div style={{
                                                        margin: '0 auto',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        width: '90%'
                                                    }}>
                                                        <Barcode
                                                            value={trackingCode}
                                                            renderer="img"
                                                            className='barcode w-full'
                                                            width={2}
                                                            height={40}
                                                            fontSize={0}
                                                            margin={0}
                                                            displayValue={false}
                                                        />
                                                    </div>

                                                    <div style={{
                                                        fontSize: '5cqw',
                                                        marginTop: '2cqw',
                                                        textAlign: 'center'
                                                    }}>{trackingCode}</div>
                                                </div>

                                                {/* Left side logo */}
                                                <div style={{ width: '15%' }}>
                                                    {/* <img src={`${process.env.PUBLIC_URL}/taroff_logo.png`} alt="Taroff Logo" style={{ width: '100%' }} /> */}
                                                    <img src={`${TAROFF_API_URL}/shops/${order.shop_id}/logo.png`} alt="Taroff Logo" style={{ width: '100%' }} />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Third label - Bottom barcode with QR */}
                                        <div className="tracking-label" style={{
                                            position: 'relative',
                                            padding: '0',
                                            marginBottom: '2cqw',
                                            // borderRadius: '8px',
                                            // border: '1px solid #eee',
                                            backgroundColor: '#fff'
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}>
                                                {/* Barcode section */}
                                                <div style={{
                                                    flexGrow: 1,
                                                    marginLeft: '6cqw',
                                                    width: '66%'
                                                }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '1cqw', justifyContent: 'center', marginBottom: '2cqw' }}>
                                                        <img src={`${process.env.PUBLIC_URL}/post-logo-small.png`} alt="Post Logo" style={{ width: '10%' }} />
                                                        برای اطلاع از قوانین و مقررات و الزامات سرویس، اسکن کنید:
                                                        <img src={`${process.env.PUBLIC_URL}/taroff_logo-small.png`} alt="Taroff Logo" style={{ width: '10%' }} />
                                                    </div>
                                                    <div style={{
                                                        margin: '0 auto',
                                                        display: 'flex',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <div style={{
                                                            width: '90%'
                                                        }}>
                                                            <Barcode
                                                                value={trackingCode}
                                                                renderer="img"
                                                                className='barcode w-full'
                                                                width={2}
                                                                height={40}
                                                                fontSize={0}
                                                                margin={0}
                                                                displayValue={false}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{
                                                        fontSize: '5cqw',
                                                        marginTop: '2cqw',
                                                        textAlign: 'center'
                                                    }}>{trackingCode}</div>
                                                </div>

                                                {/* QR code */}
                                                <div style={{ width: '20%' }}>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        width: '100%'
                                                    }}>
                                                        <div style={{ marginBottom: '2cqw', backgroundColor: '#eee', color: '#000', borderRadius: '2cqw', padding: '1cqw', textAlign: 'center' }}>
                                                            پیشتاز
                                                        </div>
                                                        <QRCodeSVG
                                                            value={trackingCode}
                                                            size={'100%'}
                                                            className='qr-code w-full'
                                                            level="H"
                                                            includeMargin={false}
                                                        />
                                                        <div style={{ marginTop: '2cqw', textAlign: 'center' }}>
                                                            رهگیری در سایت <br />
                                                            tracking.post.ir
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })
                )}
            </div>
        </div>
        <Row>
            <LeftComponents>
                <Button onClick={onDismiss}>انصراف</Button>
                <Button onClick={printInvoice} disabled={invoiceData.data.length === 0}>پرینت</Button>
            </LeftComponents>
        </Row>
    </>
}


const AssignBarcodeModal = ({ onDismiss }) => {
    const [filterQShopIdOptions, setFilterQShopIdOptions] = useState([]);

    useEffect(() => {
        postData('/api/panel/page/taroff-pre-print-barcodes/select-data/q-shop-id').then(
            (response) => {
                setFilterQShopIdOptions(response.data);
            }
        );
    }, []);

    // State for assign barcode modal
    const [assignCount, setAssignCount] = useState(1);
    const [assignShopId, setAssignShopId] = useState('');
    const [assignLoading, setAssignLoading] = useState(false);
    const [assignMessage, setAssignMessage] = useState('');

    // Function to handle submitting barcode assignment
    const handleAssignBarcodes = () => {
        setAssignLoading(true);
        setAssignMessage('');

        postData('/api/panel/page/taroff-pre-print-barcodes/assign-to-shop', {
            shop_id: parseInt(assignShopId),
            count: assignCount
        }).then((response) => {
            if (response.status === 'success') {
                const count = response.data.count;
                setAssignMessage(`${count} بارکد با موفقیت به فروشگاه تخصیص داده شد.`);
            } else {
                setAssignMessage('خطا در تخصیص بارکدها.');
            }
            setAssignLoading(false);
        }).catch(error => {
            console.error('Error assigning barcodes:', error);
            setAssignMessage('خطا در تخصیص بارکدها.');
            setAssignLoading(false);
        });
    };

    return <div className="w-full sm:w-96 p-6 bg-white dark:bg-zinc-800 rounded-lg shadow-lg">
        <div className="mb-6 border-b pb-3 dark:border-gray-700">
            <Title>تخصیص بارکدها به فروشگاه</Title>
        </div>

        <div className="space-y-4">
            <div>
                <DataSelect
                    label={'فروشگاه'}
                    options={filterQShopIdOptions}
                    value={assignShopId}
                    onChange={setAssignShopId}
                />
            </div>

            <div>
                <TextBox
                    label={'تعداد بارکد'}
                    value={assignCount}
                    onChange={(value) => setAssignCount(parseInt(value) || 1)}
                />
            </div>

            {assignMessage && (
                <div className="p-3 rounded-md text-center" style={{ backgroundColor: assignMessage.includes('موفقیت') ? 'rgba(0, 128, 0, 0.1)' : 'rgba(255, 0, 0, 0.1)' }}>
                    <TextView color={assignMessage.includes('موفقیت') ? 'success' : 'error'}>
                        {assignMessage}
                    </TextView>
                </div>
            )}
        </div>

        <div className="flex justify-between mt-8 pt-3 border-t border-gray-200 dark:border-gray-700">
            <Button
                onClick={onDismiss}
                color={'secondary'}
            >
                انصراف
            </Button>
            <Button
                onClick={handleAssignBarcodes}
                disabled={!assignShopId || assignCount < 1 || assignLoading}
                color={'primary'}
                rightIcon={'far fa-check'}
            >
                ذخیره
            </Button>
        </div>
    </div>
}


export default function TaroffPrePrintBarcodes(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };

    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);

    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };

    const clearFilters = () => {
        setFilterQShopId('');
        setFromBarcode('');
        setToBarcode('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setFilterQAssignTimeFrom('');
        setFilterQAssignTimeTo('');
        setSearchParams({});
    };

    const applyFilters = () => {
        const newSearchParams = {};
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        fromBarcode && (newSearchParams['from-barcode'] = fromBarcode);
        toBarcode && (newSearchParams['to-barcode'] = toBarcode);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        filterQAssignTimeFrom && (newSearchParams['q-assign-time-from'] = filterQAssignTimeFrom);
        filterQAssignTimeTo && (newSearchParams['q-assign-time-to'] = filterQAssignTimeTo);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };

    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQShopIdOptions, setFilterQShopIdOptions] = useState([]);
    const [fromBarcode, setFromBarcode] = useState(allProps['from-barcode'] || '');
    const [toBarcode, setToBarcode] = useState(allProps['to-barcode'] || '');
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(allProps['q-insert-time-from'] || '');
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(allProps['q-insert-time-to'] || '');
    const [filterQAssignTimeFrom, setFilterQAssignTimeFrom] = useState(allProps['q-assign-time-from'] || '');
    const [filterQAssignTimeTo, setFilterQAssignTimeTo] = useState(allProps['q-assign-time-to'] || '');

    useEffect(() => {
        postData('/api/panel/page/taroff-pre-print-barcodes/select-data/q-shop-id').then(
            (response) => {
                setFilterQShopIdOptions(response.data);
            }
        );
    }, []);

    useEffect(() => {
        postData('/api/panel/page/taroff-pre-print-barcodes/table-data', {
            'q_shop_id': filterQShopId,
            'from_barcode': fromBarcode,
            'to_barcode': toBarcode,
            'q_insert_time_from': filterQInsertTimeFrom,
            'q_insert_time_to': filterQInsertTimeTo,
            'q_assign_time_from': filterQAssignTimeFrom,
            'q_assign_time_to': filterQAssignTimeTo,
            size: tableSize,
            page: tablePage,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);

    const prePrintInvoiceModal = () => {
        setModal(
            Modal({
                children: <PrePrintInvoice onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    }

    // Function to handle barcode assignment
    const openAssignBarcodeModal = () => {
        setModal(
            Modal({
                children: <AssignBarcodeModal onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
                width: '450px'
            })
        );
    };


    return (
        <PanelBox>
            <Title>بارکدهای پیش چاپ</Title>
            <Row>
                <RightComponents wrap={true}>
                    <MultiSelectBox
                        label={'فروشگاه'}
                        options={filterQShopIdOptions}
                        value={filterQShopId}
                        onChange={setFilterQShopId}
                        width={'200px'}
                    />
                    <SearchBox
                        onEnter={applyFilters}
                        label={'از بارکد'}
                        value={fromBarcode}
                        onChange={setFromBarcode}
                        width={'150px'}
                    />
                    <SearchBox
                        onEnter={applyFilters}
                        label={'تا بارکد'}
                        value={toBarcode}
                        onChange={setToBarcode}
                        width={'150px'}
                    />
                    <SearchDateBox
                        onEnter={applyFilters}
                        label={'زمان درج از'}
                        value={filterQInsertTimeFrom}
                        onChange={setFilterQInsertTimeFrom}
                        width={'150px'}
                    />
                    <SearchDateBox
                        onEnter={applyFilters}
                        label={'زمان درج تا'}
                        value={filterQInsertTimeTo}
                        onChange={setFilterQInsertTimeTo}
                        width={'150px'}
                    />
                    <SearchDateBox
                        onEnter={applyFilters}
                        label={'زمان تخصیص از'}
                        value={filterQAssignTimeFrom}
                        onChange={setFilterQAssignTimeFrom}
                        width={'150px'}
                    />
                    <SearchDateBox
                        onEnter={applyFilters}
                        label={'زمان تخصیص تا'}
                        value={filterQAssignTimeTo}
                        onChange={setFilterQAssignTimeTo}
                        width={'150px'}
                    />
                    <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                        جستجو
                    </Button>
                    <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                        پاک کردن
                    </Button>
                    <Button rightIcon={'far fa-tags'} onClick={openAssignBarcodeModal}>
                        تخصیص بارکد به فروشگاه
                    </Button>
                    <Button onClick={prePrintInvoiceModal} color={'secondary'}>فاکتور پریپرینت</Button>
                </RightComponents>
            </Row>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>فروشگاه</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                        <TableColumn mobile={false}>زمان تخصیص</TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_shop_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-datetime-normal'}>
                                    {row.text_insert_time}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-datetime-normal'}>
                                    {row.text_assign_time}
                                </TextView>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
